import { expectDefined } from '@utils';
import { DEFAULT_LOCALE_ID, LocaleId } from './LocaleId';
import localesJson from './locales.json';
import { lookupString } from './lookupString';
import type { StringId } from './StringId';
import { interpolateString } from './stringUtils';

const localesData = localesJson as unknown as Record<LocaleId, LocaleData> | undefined;

export class Locale {
  _id: LocaleId;
  _data: LocaleData;

  constructor(id: LocaleId) {
    this._id = id;
    this._data = expectDefined(localesData)[id];
  }

  get id(): LocaleId {
    return this._id;
  }

  get description(): string {
    return this._data.description;
  }

  get language(): string {
    return this._data.language;
  }

  getString(stringId: StringId, placeholders?: Record<string, string>): string {
    const s = lookupString(stringId, this._id, true);
    if (s === undefined) {
      return stringId;
    }
    return interpolateString(s, placeholders);
  }

  static localizedString(
    stringId: StringId,
    localeId?: LocaleId,
    placeholders?: Record<string, string>
  ): string {
    const locale = Locale.getLocale(localeId ?? DEFAULT_LOCALE_ID);
    return locale.getString(stringId, placeholders);
  }

  static getLocale(id: LocaleId): Locale {
    let locale = locales.get(id);
    if (!locale) {
      locale = new Locale(id);
      locales.set(id, locale);
    }
    return locale;
  }
}

interface LocaleData {
  description: string;
  language: string;
}

export const locales = new Map<LocaleId, Locale>();

function setupLocales() {
  for (const id of Object.values(LocaleId)) {
    Locale.getLocale(id);
  }
}

setupLocales();
